import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import type { CalculationQuality } from "@/types";

/** Keep assumed inputs next to the target, not hidden in a calculation drawer. */
export function ProvisionalTargetNote({ quality }: { quality?: CalculationQuality }) {
  const { t } = useTranslation();
  if (!quality?.provisional && !quality?.deficit_blocked) return null;
  const fields = (quality.assumed_fields ?? []).map((field) => {
    const value = quality.input_values?.[field];
    const formatted = field === "sex"
      ? t(value === "F" ? "common.formula_female" : "common.formula_male")
      : `${value ?? "—"}${field === "weight_kg" ? " kg" : field === "height_cm" ? " cm" : ""}`;
    return `${t(`common.body_input_${field}`)}: ${formatted}`;
  });
  return <div className="mt-2 rounded-lg border border-amber/30 bg-amber/10 px-3 py-2 text-[12px] text-navy" data-testid={quality.provisional ? "provisional-target" : "restricted-target"}>
    {quality.provisional && <p className="font-medium">{t("common.provisional_target")}</p>}
    {fields.length > 0 ? <p className="mt-1">{t("common.assumed_inputs", { inputs: fields.join(" · ") })}</p> : null}
    {quality.deficit_blocked && <p className="mt-1">{t("diary_quality.profile_limit")}</p>}
    <Link className="mt-1 inline-block underline" to="/settings">{t("nav.settings", "Settings")}</Link>
  </div>;
}
